(() => {
  const cfg = window.spConfig || { t: {}, routes: { cartAdd: '/cart/add' } };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = cfg.moneyFormat || '{{amount}}';
    const n = (Number(cents) || 0) / 100;
    const fx = (dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fx(2, ',', '.'),
      amount_no_decimals: fx(0, ',', '.'),
      amount_with_comma_separator: fx(2, '.', ','),
      amount_no_decimals_with_comma_separator: fx(0, '.', ','),
      amount_with_apostrophe_separator: fx(2, "'", '.'),
      amount_with_space_separator: fx(2, ' ', ','),
    }[k] || fx(2, ',', '.')));
  }

  async function addItems(items, withSections) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (withSections && drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    const res = await fetch(`${cfg.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    let json;
    try { json = await res.json(); } catch (_) { throw new Error(cfg.t.error); }
    if (!res.ok || json.status) throw new Error(json.description || json.message || cfg.t.error);
    if (withSections) {
      if (drawer && json.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
      } else {
        window.location.href = cfg.routes.cart;
      }
    }
    return json;
  }

  function initProduct(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    const variants = JSON.parse($('[data-sp-variants]', root).textContent);
    let variant = variants.find((v) => String(v.id) === $('[data-sp-variant-id]', root).value) || variants[0];
    const addBtn = $('[data-sp-add]', root);
    const buyNow = $('[data-sp-buynow]', root);
    const errorEl = $('[data-sp-error]', root);
    const form = $('[data-sp-form]', root);

    // Gallery
    const track = $('[data-sp-track]', root);
    const thumbs = $$('[data-sp-thumb]', root);
    const dots = $$('[data-sp-dots] span', root);
    const goTo = (i) => track && track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.spThumb))));
    if (track) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      }, { passive: true });
    }

    const selectedBundle = () => $('[data-sp-bundle].is-selected', root);
    const qtyInput = $('[data-sp-qty]', root);
    const getQty = () => {
      const b = selectedBundle();
      if (b) return Number(b.dataset.qty);
      return Math.max(1, Number(qtyInput ? qtyInput.value : 1) || 1);
    };

    function renderBundles() {
      const compareUnit = variant.compare > variant.price ? variant.compare : variant.price;
      $$('[data-sp-bundle]', root).forEach((b) => {
        const qty = Number(b.dataset.qty);
        const paid = Number(b.dataset.paid);
        const pct = Number(b.dataset.pct);
        const total = Math.round(variant.price * paid * (1 - pct / 100));
        const was = compareUnit * qty;
        $('[data-sp-bundle-total]', b).textContent = formatMoney(total);
        const grand = $('[data-sp-bundle-grand]', b);
        if (grand) grand.textContent = formatMoney(total + (Number(b.dataset.ship) || 0));
        const wasEl = $('[data-sp-bundle-was]', b);
        wasEl.textContent = was > total ? formatMoney(was) : '';
        $('[data-sp-bundle-unit]', b).textContent = qty > 1 ? `${formatMoney(Math.round(total / qty))} ${cfg.t.perUnit}` : '';
        const save = was - total;
        const saveEl = $('[data-sp-bundle-save]', b);
        saveEl.classList.toggle('is-hidden', save <= 0);
        $('[data-sp-bundle-save-amount]', b).textContent = formatMoney(save);
        if (b.classList.contains('is-selected')) root.dataset.total = total;
      });
    }

    function renderStock() {
      const el = $('[data-sp-stock]', root);
      if (!el) return;
      if (!variant.tracked || !variant.available || variant.inv <= 0) return el.classList.add('is-hidden');
      el.classList.remove('is-hidden');
      const low = variant.inv <= Number(el.dataset.threshold);
      el.classList.toggle('is-low', low);
      $('[data-sp-stock-text]', el).textContent = low ? cfg.t.stockLow.replace('{{ count }}', variant.inv).replace('{{count}}', variant.inv) : cfg.t.stockIn;
      const fill = Math.max(6, Math.min(100, (variant.inv / Number(el.dataset.ref)) * 100));
      $('[data-sp-stock-fill]', el).style.width = `${fill}%`;
    }

    const xsells = $$('[data-sp-xsell]', root);
    const xsellInput = (x) => $('[data-sp-xsell-variant]', x);
    const xsellPrice = (x) => {
      const el = xsellInput(x);
      return Number((el.tagName === 'SELECT' ? el.selectedOptions[0] : el).dataset.price) || 0;
    };
    const xsellTotal = () => xsells.filter((x) => x.classList.contains('is-added')).reduce((sum, x) => sum + xsellPrice(x), 0);
    xsells.forEach((x) => {
      const btn = $('[data-sp-xsell-toggle]', x);
      btn.addEventListener('click', () => {
        const on = !x.classList.contains('is-added');
        x.classList.toggle('is-added', on);
        btn.setAttribute('aria-pressed', String(on));
        update(false);
      });
      const sel = xsellInput(x);
      if (sel.tagName === 'SELECT') sel.addEventListener('change', () => {
        const o = sel.selectedOptions[0];
        $('[data-sp-xsell-price]', x).textContent = formatMoney(o.dataset.price);
        const cmp = $('[data-sp-xsell-compare]', x);
        cmp.textContent = formatMoney(o.dataset.compare);
        cmp.classList.toggle('is-hidden', Number(o.dataset.compare) <= Number(o.dataset.price));
        update(false);
      });
    });

    function update(fromUser) {
      $('[data-sp-variant-id]', root).value = variant.id;
      const pct = variant.compare > variant.price ? Math.round(((variant.compare - variant.price) * 100) / variant.compare) : 0;
      $$('[data-sp-price]', root).forEach((e) => (e.textContent = formatMoney(variant.price)));
      $$('[data-sp-compare]', root).forEach((e) => { e.textContent = formatMoney(variant.compare); e.classList.toggle('is-hidden', !pct); });
      $$('[data-sp-pct]', root).forEach((e) => (e.textContent = pct));
      $$('[data-sp-save-pill],[data-sp-round-badge]', root).forEach((e) => e.classList.toggle('is-hidden', !pct));
      renderBundles();
      renderStock();
      const total = (selectedBundle() ? Number(root.dataset.total) : variant.price * getQty()) + xsellTotal();
      const priceEl = $('[data-sp-add-price]', root);
      if (priceEl) priceEl.textContent = variant.available ? `· ${formatMoney(total)}` : '';
      const sticky = $('[data-sp-sticky-price]', root);
      if (sticky) sticky.textContent = formatMoney(total);
      [addBtn, buyNow, $('[data-sp-sticky-add]', root)].forEach((b) => b && (b.disabled = !variant.available));
      const label = $('[data-sp-add-label]', root);
      if (label) {
        if (!label.dataset.default) label.dataset.default = label.textContent;
        label.textContent = variant.available ? label.dataset.default : cfg.t.soldOut;
      }
      if (fromUser && variant.media && track) {
        const slides = $$('.sp-gallery__slide', track);
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.media));
        if (idx >= 0) goTo(idx);
      }
      if (fromUser && document.body.classList.contains('template-product')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-sp-option]', root).forEach((fs) =>
      fs.addEventListener('change', () => {
        const values = $$('[data-sp-option]', root).map((f) => ($('input:checked', f) || {}).value);
        $$('[data-sp-option]', root).forEach((f, i) => ($('[data-sp-option-label]', f).textContent = values[i]));
        const match = variants.find((v) => v.options.every((o, i) => o === values[i]));
        if (match) variant = match;
        else variant = { ...variant, available: false };
        update(true);
      })
    );

    $$('[data-sp-bundle]', root).forEach((b) =>
      b.addEventListener('click', () => {
        $$('[data-sp-bundle]', root).forEach((x) => x.classList.toggle('is-selected', x === b));
        $('input', b).checked = true;
        update(false);
      })
    );

    $$('[data-sp-qty-step]', root).forEach((btn) =>
      btn.addEventListener('click', () => {
        qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + Number(btn.dataset.spQtyStep));
        update(false);
      })
    );
    if (qtyInput) qtyInput.addEventListener('change', () => update(false));

    function buildItems() {
      const items = [{ id: variant.id, quantity: getQty() }];
      const b = selectedBundle();
      if (b) b.dataset.gifts.split(',').filter(Boolean).forEach((id) => items.push({ id: Number(id), quantity: 1 }));
      $$('[data-sp-addon]:checked', root).forEach((c) => items.push({ id: Number(c.value), quantity: 1 }));
      xsells.filter((x) => x.classList.contains('is-added')).forEach((x) => items.push({ id: Number(xsellInput(x).value), quantity: 1 }));
      if (cfg.preorder) items.forEach((it) => (it.properties = { [cfg.preorder.prop]: cfg.preorder.value }));
      return items;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.toggle('is-hidden', !msg);
    }

    async function submit(btn, checkout) {
      if (!variant.available) return;
      showError('');
      btn && btn.classList.add('is-loading');
      try {
        await addItems(buildItems(), !checkout);
        document.dispatchEvent(new CustomEvent('sp:added', { detail: { pid: root.dataset.spPid } }));
        if (checkout) window.location.href = '/checkout';
      } catch (e) {
        showError(e.message);
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    }

    form.addEventListener('submit', (e) => { e.preventDefault(); submit(addBtn, false); });
    if (buyNow) buyNow.addEventListener('click', () => submit(buyNow, true));

    const stickyBar = $('[data-sp-sticky]', root);
    if (stickyBar && addBtn) {
      $('[data-sp-sticky-add]', stickyBar).addEventListener('click', (e) => submit(e.currentTarget, false));
      let ticking = false;
      const check = () => {
        ticking = false;
        const show = addBtn.getBoundingClientRect().bottom < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
    }

    // UGC modal
    const modal = $('[data-sp-modal]', root);
    if (modal) {
      const body = $('[data-sp-modal-body]', modal);
      const close = () => { modal.hidden = true; body.innerHTML = ''; document.documentElement.classList.remove('sp-lock'); };
      $$('[data-sp-ugc]', root).forEach((item) =>
        item.addEventListener('click', () => {
          const v = $('video', item);
          const img = $('img', item);
          if (v) {
            const nv = v.cloneNode(true);
            nv.muted = true; nv.controls = true; nv.loop = true; nv.playsInline = true; nv.autoplay = true;
            nv.removeAttribute('preload');
            body.appendChild(nv);
            nv.play().catch(() => {});
          } else if (img) {
            const ni = img.cloneNode(true);
            ni.removeAttribute('sizes'); ni.removeAttribute('srcset');
            ni.src = img.src.replace(/width=\d+/, 'width=1200');
            body.appendChild(ni);
          } else return;
          modal.hidden = false;
          document.documentElement.classList.add('sp-lock');
        })
      );
      $('[data-sp-modal-close]', modal).addEventListener('click', close);
      modal.addEventListener('click', (e) => e.target === modal && close());
      document.addEventListener('keydown', (e) => e.key === 'Escape' && !modal.hidden && close());
    }

    update(false);
  }

  const tz = (cfg.tz || '+03:00').trim();
  const tzMin = (() => { const m = tz.match(/^([+-])(\d{2}):?(\d{2})$/); return m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : -new Date().getTimezoneOffset(); })();
  const storeNow = () => new Date(Date.now() + (tzMin + new Date().getTimezoneOffset()) * 60000);

  function addBusinessDays(date, days, weekends) {
    const d = new Date(date);
    let n = days;
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (weekends || (d.getDay() !== 0 && d.getDay() !== 6)) n--;
    }
    if (!weekends) while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  function initDelivery(el) {
    const lang = document.documentElement.lang || 'tr';
    const now = storeNow();
    const weekends = el.dataset.weekends === 'true';
    let start = new Date(now);
    if (now.getHours() >= Number(el.dataset.cutoff)) start.setDate(start.getDate() + 1);
    const ship = addBusinessDays(start, Number(el.dataset.process), weekends);
    if (!weekends) while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
    const sameDay = (a, b) => a.toDateString() === b.toDateString();
    const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);
    const fmt = (d) => d.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' });
    $('[data-sp-ship-day]', el).textContent = sameDay(ship, now) ? cfg.t.today : sameDay(ship, tomorrow) ? `${cfg.t.tomorrow} (${fmt(ship)})` : fmt(ship);
    const range = $('[data-sp-deliver-range]', el);
    if (range) {
      const short = (d) => d.toLocaleDateString(lang, { day: 'numeric', month: 'short', weekday: 'short' });
      const a = addBusinessDays(ship, Number(el.dataset.min), false);
      const b = addBusinessDays(ship, Number(el.dataset.max), false);
      range.textContent = Number(el.dataset.min) === Number(el.dataset.max) ? short(b) : `${short(a)} – ${short(b)}`;
    }
  }

  function initCountdown(el) {
    let raw = el.dataset.spCountdown.trim().replace(' ', 'T');
    if (raw.length <= 16) raw += (raw.length === 10 ? 'T23:59' : '') + ':00' + tz.replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
    const end = new Date(raw);
    if (isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = end - new Date();
      if (diff <= 0) { el.remove(); return; }
      el.classList.remove('is-hidden');
      const s = Math.floor(diff / 1000);
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', el).textContent = pad(Math.floor((s % 86400) / 3600));
      $('[data-m]', el).textContent = pad(Math.floor((s % 3600) / 60));
      $('[data-s]', el).textContent = pad(s % 60);
      setTimeout(tick, 1000);
    };
    tick();
  }

  function initBeforeAfter(frame) {
    const range = $('[data-sp-ba-range]', frame);
    const tags = $$('.sp-ba__tag', frame);
    const set = () => {
      const v = Number(range.value);
      frame.style.setProperty('--pos', `${v}%`);
      if (tags[0]) tags[0].style.opacity = v < 12 ? 0 : 1;
      if (tags[1]) tags[1].style.opacity = v > 88 ? 0 : 1;
    };
    range.addEventListener('input', set);
    let start = null;
    let dragging = false;
    const moveTo = (x) => {
      const r = frame.getBoundingClientRect();
      range.value = Math.round(Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100)));
      set();
    };
    frame.addEventListener('dragstart', (e) => e.preventDefault());
    frame.addEventListener('pointerdown', (e) => {
      if (e.button > 0) return;
      if (e.pointerType === 'mouse') e.preventDefault();
      start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      dragging = e.pointerType === 'mouse';
      if (dragging) { frame.setPointerCapture(e.pointerId); frame.classList.add('is-dragging'); moveTo(e.clientX); }
    });
    frame.addEventListener('pointermove', (e) => {
      if (!start) return;
      if (!dragging) {
        const dx = Math.abs(e.clientX - start.x);
        const dy = Math.abs(e.clientY - start.y);
        if (dy > 8 && dy > dx) { start = null; return; }
        if (dx > 6) { dragging = true; frame.setPointerCapture(start.id); frame.classList.add('is-dragging'); }
      }
      if (dragging) moveTo(e.clientX);
    });
    const end = (e) => {
      if (start && !dragging && e.type === 'pointerup') moveTo(e.clientX);
      start = null;
      dragging = false;
      frame.classList.remove('is-dragging');
    };
    ['pointerup', 'pointercancel'].forEach((ev) => frame.addEventListener(ev, end));
    set();
  }

  function initFbt(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    const rows = $$('[data-sp-fbt-row]', root);
    const btn = $('[data-sp-fbt-add]', root);
    const label = $('[data-sp-fbt-label]', root);
    const opt = (row) => {
      const el = $('[data-sp-fbt-variant]', row);
      return el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
    };
    const on = () => rows.filter((r) => $('[data-sp-fbt-check]', r).checked);
    const render = () => {
      let total = 0;
      let compare = 0;
      rows.forEach((r) => {
        const o = opt(r);
        const price = Number(o.dataset.price) || 0;
        const cmp = Number(o.dataset.compare) || 0;
        const checked = $('[data-sp-fbt-check]', r).checked;
        r.classList.toggle('is-on', checked);
        const thumb = $(`[data-sp-fbt-thumb="${r.dataset.spFbtRow}"]`, root);
        if (thumb) thumb.classList.toggle('is-off', !checked);
        $('[data-sp-fbt-row-price]', r).textContent = formatMoney(price);
        const rc = $('[data-sp-fbt-row-compare]', r);
        rc.textContent = formatMoney(cmp);
        rc.classList.toggle('is-hidden', cmp <= price);
        if (checked) { total += price; compare += Math.max(cmp, price); }
      });
      $('[data-sp-fbt-total]', root).textContent = formatMoney(total);
      const c = $('[data-sp-fbt-compare]', root);
      c.textContent = formatMoney(compare);
      c.classList.toggle('is-hidden', compare <= total);
      const n = on().length;
      label.textContent = (n > 1 ? label.dataset.many : label.dataset.one).replace(/\{\{\s*count\s*\}\}/g, n);
    };
    rows.forEach((r) => {
      $('[data-sp-fbt-check]', r).addEventListener('change', render);
      const sel = $('select[data-sp-fbt-variant]', r);
      if (sel) sel.addEventListener('change', render);
    });
    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const items = on().map((r) => {
          const it = { id: Number(opt(r).value), quantity: 1 };
          if (cfg.preorder) it.properties = { [cfg.preorder.prop]: cfg.preorder.value };
          return it;
        });
        await addItems(items, true);
      } catch (err) {
        alert(err.message);
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    });
    render();
  }

  function initQuotes(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    const quotes = $$('[data-sp-quote]', root);
    const dots = $$('[data-sp-quote-dot]', root);
    if (quotes.length < 2) return;
    let i = 0;
    let timer = null;
    let hovered = false;
    const ms = (Number(root.dataset.interval) || 5) * 1000;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = (n) => {
      i = (n + quotes.length) % quotes.length;
      quotes.forEach((q, k) => { q.classList.toggle('is-active', k === i); q.setAttribute('aria-hidden', String(k !== i)); });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const start = () => { clearInterval(timer); if (!reduce && !hovered) timer = setInterval(() => show(i + 1), ms); };
    const stop = () => clearInterval(timer);
    dots.forEach((d) => d.addEventListener('click', () => { show(Number(d.dataset.spQuoteDot)); start(); }));
    root.addEventListener('mouseenter', () => { hovered = true; stop(); });
    root.addEventListener('mouseleave', () => { hovered = false; start(); });
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 !== null) {
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      }
      x0 = null;
      start();
    });
    start();
  }

  function init(scope = document) {
    $$('[data-sp-quotes]', scope).forEach(initQuotes);
    $$('[data-sp-fbt]', scope).forEach(initFbt);
    $$('[data-sp-product]', scope).forEach(initProduct);
    $$('[data-sp-ba]', scope).forEach(initBeforeAfter);
    $$('[data-sp-delivery]', scope).forEach(initDelivery);
    $$('[data-sp-countdown]', scope).forEach(initCountdown);
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.target.tagName === 'VIDEO') { e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause(); return; }
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' }) : null;
    if (io) {
      $$('.sp-reveal', scope).forEach((el) => io.observe(el));
      $$('.sp-ugc video, .sp-feature video, .sp-step video', scope).forEach((v) => { v.removeAttribute('autoplay'); v.pause(); io.observe(v); });
    } else $$('.sp-reveal', scope).forEach((el) => el.classList.add('is-in'));
  }

  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-sp-copy]');
    if (copy) {
      if (copy.dataset.busy) return;
      copy.dataset.busy = '1';
      try { await navigator.clipboard.writeText(copy.dataset.spCopy); } catch (_) {}
      const old = copy.innerHTML;
      copy.textContent = cfg.t.copied;
      setTimeout(() => { copy.innerHTML = old; delete copy.dataset.busy; }, 1600);
      return;
    }
    const more = e.target.closest('[data-sp-more]');
    if (more) {
      const hidden = $$('[data-sp-review].is-hidden', more.closest('[data-sp-reviews]'));
      hidden.slice(0, Number(more.dataset.step)).forEach((r) => r.classList.remove('is-hidden'));
      if (hidden.length <= Number(more.dataset.step)) more.remove();
      return;
    }
    const scrollBuy = e.target.closest('[data-sp-scroll-buy]');
    if (scrollBuy && scrollBuy.getAttribute('href') === '#sp-top') {
      const target = $('[data-sp-bundles]') || $('[data-sp-buy-area]');
      e.preventDefault();
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.location.href = '/collections/all';
      return;
    }
    const quick = e.target.closest('[data-sp-quick-add]');
    if (quick) {
      quick.classList.add('is-loading');
      try { await addItems([{ id: Number(quick.dataset.spQuickAdd), quantity: 1 }], true); } catch (err) { alert(err.message); }
      quick.classList.remove('is-loading');
    }
  });

  document.addEventListener('submit', (e) => {
    const code = e.target.closest('[data-sp-code-form]');
    if (code) {
      e.preventDefault();
      const v = code.querySelector('input').value.trim();
      if (v) window.location.href = `/discount/${encodeURIComponent(v)}?redirect=/checkout`;
      return;
    }
    const track = e.target.closest('[data-sp-track]');
    if (track) {
      e.preventDefault();
      const v = track.querySelector('input').value.trim();
      if (v) window.open(track.dataset.spTrack.replace('{number}', encodeURIComponent(v)), '_blank', 'noopener');
    }
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
